import React from "react";
import { Button, InputJson } from "nq-component";
import {
  findObjectUseCase,
  getObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import BaseFormPage from "../../../../base/BaseFormPage";
import NavBar from "../../../../components/navigation";
import FormFactory from "../../../../components/FormFactory";
import OBRequestFormPresenter from "./OBRequestFormPresenter";

class OBRequestFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      advanced: false,
      objectID: "",
      object: {},
    };
    this.presenter = new OBRequestFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "ob_requests";
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
  }

  setObject(object) {
    this.setState({ object });
  }

  onChange(value, field) {
    this.presenter.onChange(value, field);
  }

  render() {
    const { object } = this.state;

    const advanced = this.state.advanced;
    const schema = this.getSchema(this.getCollectionName());
    const label = this.getObjectId() === undefined ? "Submit" : "Update ";
    const isViewMode = this.props.location.state?.isViewMode;

    if (!schema) return <h1>no schema</h1>;

    let excludeFields = [];
    if (object.status !== "Disapproved") {
      excludeFields = ["reason"];
    }

    return (
      <>
      <div className="overflow-auto mt-5">
        <div className="h-100">
          <div className="p-3 p-lg-4">
            <h1 className="fw-bold mt-3 text-capitalize">
              {(schema.label || this.getCollectionName()) + " Details"}
            </h1>
            <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  this.presenter.save();
                }}
              >
                  <div className="row g-3">
                  {advanced ? (
                    <InputJson
                      defaultValue={object}
                      onChange={this.presenter.onChangeObject.bind(this)}
                      rows="15"
                    />
                  ) : (
                    <FormFactory
                      schema={schema}
                      object={object}
                      disabled={isViewMode}
                      onChange={this.onChange.bind(this)}
                      excludeFields={excludeFields}
                    />
                  )}
                </div>

                <div className="mt-4">
                  <button
                    type="button"
                    className="btn btn-light fs-sm"
                    onClick={this.onClickBack.bind(this)}
                  >
                    GO BACK
                  </button>
                  {!isViewMode && (  
                  <button
                    type="submit"
                    className="btn btn-primary fs-sm ms-2 me-3"
                  >
                    <i className="bi bi-file-earmark-check me-2"></i>
                    {label}
                  </button>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
    );
  }
}

export default withRouter(OBRequestFormPage);
